import React, { useEffect, useState } from 'react';
import { adminService } from '../services/adminService';

type Reviews = Awaited<ReturnType<typeof adminService.getPartnerUnlockReviews>>;

const PartnerUnlockReviews: React.FC = () => {
  const [reviews, setReviews] = useState<Reviews | null>(null);
  const [error, setError] = useState(false);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setReviews(null);
    setError(false);
    adminService.getPartnerUnlockReviews().then(data => {
      if (!cancelled) setReviews(data);
    }).catch(() => {
      if (!cancelled) setError(true);
    });
    return () => { cancelled = true; };
  }, [refresh]);

  return <section className="economy-settings-group" aria-labelledby="partner-reviews-heading">
    <h4 id="partner-reviews-heading">Cancelled partner unlocks — review required</h4>
    <p>Already-used stakes are flagged here. No automatic wallet deduction is made.</p>
    <button type="button" onClick={() => setRefresh(value => value + 1)}>Refresh reviews</button>
    {error ? <p role="alert">Unable to load partner reviews. Please retry.</p>
      : reviews === null ? <p role="status">Loading reviews…</p> : <>
        <p>{reviews.unmatched_callbacks} callbacks require attribution investigation.</p>
        {reviews.review_required.length === 0 ? <p>No used unlocks need review.</p> : <ul>
          {reviews.review_required.map(item => <li key={item.unlock_id}>
            {item.partner} · User {item.user_id} · {item.workspace} · {item.stake_tp} TP
            {' · '}{item.game_id !== null ? `Standard session ${item.game_id}` : `Pro session ${item.pro_session_id}`}
            {' · '}Unlock {item.unlock_id}
          </li>)}
        </ul>}
      </>}
  </section>;
};

export default PartnerUnlockReviews;
